export const API_CALL_ERROR = 'API_CALL_ERROR'
export const REQUEST_ORGS = 'REQUEST_ORGS'

export const asyncFetch = (url, authSession, payload) => {
  console.log('asyncfetch...', payload)
  let apiAuthHeaders = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'X-CB-Catapult-Authentication-Token': JSON.parse(authSession).authnToken,
    'X-CB-Catapult-Authorization-Token': JSON.parse(authSession).authzToken
  }
  return dispatch => {
    return fetch(url, {
      method: 'POST',
      dataType: 'jsonp',
      headers: apiAuthHeaders,
      body: payload
    }).then(response => response.json()).then((responseData) => {
      dispatch({
        type: REQUEST_ORGS,
        data: {
          ...responseData,
          apiHeaders: apiAuthHeaders
        }
      })
    }).catch(err => {
      console.log('ERROR when calling /requestvalidation', err)
      dispatch({
        type: API_CALL_ERROR,
        data: {
          isLoading: false,
          unauthorized: true
        }
      })
    })
  }
}
